var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symbol-search-index"},[_c('Filters',{attrs:{"filters":_vm.symbolSearchFilters,"filter-key":"symbolSearch","initial-data":_vm.filtersStatus.symbolSearch,"loading":_vm.filtersLoading}}),_c('TableWrapper',{attrs:{"table-columns":_vm.symbolSearchColumns,"table-key":"symbolSearch","row-key":"tableId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }